module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-plumbing@2x.png?8245ddf6a81c2c70defbadbdea52971d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-plumbing@2x.png
// module id = 1041
// module chunks = 1